import { getAgenciesForFranchiseOwner, getAllAgencies } from "api/agency.js";
import classnames from "classnames";
import Select from "components/Elements/Select.js";
import AppContext from "Contexts/AppContext.js";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Role } from "utils/common.js";
// components
import DropdownUser from "../../components/Dropdowns/DropdownUser.js";
export default function NavbarSearchUser({ brand, input, dropdown }) {
  const {
    user,
    displayErrorMessage,
    setSelectedAgency,
    selectedAgency,
    setIsSuperAdmin,
    setIsAdmin,
    logoutHandler
  } = useContext(AppContext);
  const [agencies, setAgencies] = useState([]);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [collapseStyle, setCollapseStyle] = React.useState(undefined);
  const [animation, setAnimation] = React.useState(false);
  const collapseRef = React.useRef(null);
  const startAnitmation = () => {
    if (!animation) {
      setAnimation(true);
      if (collapseOpen) {
        setCollapseStyle(0);
        setTimeout(function () {
          setAnimation(false);
          setCollapseOpen(false);
        }, 310);
      } else {
        setCollapseOpen(true);
        setTimeout(function () {
          setCollapseStyle(collapseRef.current.scrollHeight);
        }, 10);
        setTimeout(function () {
          setAnimation(false);
        }, 310);
      }
    }
  };

  const getAgenciesForUser = async () => {
    const department = user?.department?.trim()?.toLowerCase();
    const office = user?.officeLocation?.trim()?.toLowerCase();
    const agencySelectionPermissions = [Role.SUPER_ADMIN, Role.ADMIN];
    const isAllowedAgencySelection = agencySelectionPermissions
      .map((p) => p?.trim()?.toLowerCase())
      .includes(department);
    const isSuperAdmin = department === Role.SUPER_ADMIN.toLowerCase();
    const isAdmin = department === Role.ADMIN.toLowerCase();

    setIsSuperAdmin(isSuperAdmin);

    setIsAdmin(isAdmin);

    if (isAllowedAgencySelection) {
      try {
        let data = [];
        if (isSuperAdmin) {
          data = await getAllAgencies();
        } else {
          data = await getAgenciesForFranchiseOwner(user?.userPrincipalName);
        }

        if (data?.length > 0) {
          const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
          setAgencies(data.map((d) => d.name));

          if (selectedAgency.length === 0)
            setSelectedAgency(sortedData[0]?.name);
        } else {
          if (selectedAgency.length === 0) setSelectedAgency(office);
        }
      } catch (err) {
        console.log("err", err);
        displayErrorMessage(
          "Une erreur est survenue dans la récuperation des agences"
        );
      }
    } else if(!office) {
      logoutHandler?.()
    }
     else {
      setSelectedAgency(office);
    }
  };

  useEffect(() => {
    getAgenciesForUser();
  }, []);

  const handleAgencySelect = (agency) => {
    setSelectedAgency(agency);
  };

  return (
    <>
      {/* Navbar */}
      <nav className="absolute top-0 left-0 w-full z-10 bg-white lg:flex-row lg:flex-nowrap lg:justify-start flex items-center py-1 px-4 lg:bg-transparent">
        <div className="w-full mx-aut0 items-center flex justify-between lg:flex-nowrap flex-wrap lg:px-6 px-4">
          {brand && brand.to && (
            <Link
              {...brand}
              className="text-blueGray-800 lg:text-white text-sm uppercase inline-block font-semibold my-3"
            >
              {brand.children}
            </Link>
          )}
          {brand && brand.to === undefined && (
            <a
              {...brand}
              className="text-blueGray-800 lg:text-white text-sm uppercase inline-block font-semibold my-3"
            >
              {brand.children}
            </a>
          )}
          <button
            className="ml-auto cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-blueGray-400 rounded bg-transparent block outline-none focus:outline-none text-blueGray-300 lg:hidden"
            type="button"
            onClick={startAnitmation}
          >
            <i className="fas fa-bars"></i>
          </button>
          <div
            className={classnames(
              "items-center w-full lg:flex lg:w-auto flex-grow duration-300 transition-all ease-in-out lg:h-auto-important agency-select-container",
              {
                "block h-0": collapseOpen,
                hidden: !collapseOpen,
                "overflow-hidden": animation,
              }
            )}
            style={{
              height: collapseStyle,
            }}
            ref={collapseRef}
          >
            <form className="flex flex-row flex-wrap items-center ml-auto mr-3 mt-3">
              {/* <Input {...input} /> */}
            </form>
            <div className="mr-4 mt-2 agency-select-wrapper">
              <div className="mr-4">
                {agencies?.length > 0 && (
                  <Select
                    {...{
                      border: "border",
                      items: agencies,
                      value: selectedAgency,
                      defaultValue: selectedAgency,
                      onChange: handleAgencySelect,
                    }}
                  />
                )}
              </div>
              <DropdownUser {...dropdown} />
            </div>
          </div>
        </div>
      </nav>
      {/* End Navbar */}
    </>
  );
}

NavbarSearchUser.defaultProps = {
  brand: {},
  input: {},
  dropdown: {},
};

NavbarSearchUser.propTypes = {
  // properties to pass to the link object for the brand
  // if you pass a prop named to, the link will be
  // generated using Link from react-router-dom
  brand: PropTypes.object,
  // properties to pass to the Input component
  input: PropTypes.object,
  // properties to pass to the DropdownUser component
  dropdown: PropTypes.object,
};
